<template>
  <v-btn
    data-test-id="buttonAlternate"
    v-bind="$attrs"
    variant="flat"
    class="bg-secondary d-print-none"
  >
    <!-- @vue-skip -->
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData"
      ><slot :name="name" v-bind="slotData"
    /></template>
  </v-btn>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES

// PROPS & EMITS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES

// LIFECYCLE HOOKS

// FUNCTIONS
</script>
